import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const StyledLineContainerBox = styled(Box, {
    shouldForwardProp: (propName: string) => propName !== 'existing',
})`
    margin: 20px 10px;
    padding: 10px 0px;
    border-radius: 5px;

    &:hover {
        box-shadow: 0 2px 10px 2px rgba(0, 0, 0, 0.15);
    }

    &.selected {
        background: #245f88;
    }

    &:not(.existing) {
        border-color: ${({ theme }) => theme.palette.warning.main};
        border-style: solid;
        border-width: 0.4px;
    }
`;
